// import React from 'react';
// import { createRoot } from "react-dom/client";

import { initializeQuote } from './quote/quote';
import { initializeMulchCalculator, initializeMulchCalculatorBlog } from './mulch_calculator/MulchCalculator_Combined';
// import { initializePIPCalculator } from './pip_calculator/PipCalculator';
// import { initializePIPCalculatorModal } from './pip_calculator/PipCalculatorModal';
import { PIPCalculatorModalButton } from './pip_calculator/PipCalculatorModal';
import { borderCalculator } from './border_calculator/BorderCalculator';
// import { initializeBorderCalculator } from './border_calculator/BorderCalculator';
import { shadeHeightCalculator, shadeHeightSpec } from './shade_height_calculator/ShadeHeightCalculator';
// import { initializeShadeHeightCalculator } from './shade_height_calculator/ShadeHeightCalculator';

// import { initializeSurfacingCalculator } from './calculator/Calculator';
// import { Modal } from './modal/Modal';

import { renderInto } from './utils/render';


// import * as Sentry from "@sentry/react";
// Sentry.init({
//   dsn: "https://a01032b20a76b5cd242b0eb7f368a617@o4511469266993152.ingest.us.sentry.io/4511469268172800",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true,
//   integrations: [
//     // send console.log, console.warn, and console.error calls as logs to Sentry
//     Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
//   ],
//   // Enable logs to be sent to Sentry
//   enableLogs: true,
// });
// Sentry.setTag("location", "quote");



import "./styles/quote.scss";
// import "./styles/border_calculator.scss";
// import "./styles/calculators.scss";
// import "./styles/modal.scss";

renderInto('#pip-calculator-button-container', PIPCalculatorModalButton);
renderInto('#border-calculator', borderCalculator);
renderInto('#shade-height-calculator', shadeHeightCalculator);
renderInto('#shade-height-spec', shadeHeightSpec);

initializeQuote();
initializeMulchCalculator();
initializeMulchCalculatorBlog();
// initializeBorderCalculator();
// initializeShadeHeightCalculator();
// initializePIPCalculatorModal();

// initializeSurfacingCalculator();